import { render, staticRenderFns } from "./FullScreenPreview.vue?vue&type=template&id=70642bbc&scoped=true"
import script from "./FullScreenPreview.vue?vue&type=script&lang=js"
export * from "./FullScreenPreview.vue?vue&type=script&lang=js"
import style0 from "./FullScreenPreview.vue?vue&type=style&index=0&id=70642bbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70642bbc",
  null
  
)

export default component.exports